import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '~/services/fetchServiceV2';
import { TypeErrorFormat, requestHelper } from '~/utils/fetchHelper';

/** @category useCheckPw */
export type TypeCheckPwParams = {
  /** 로그인 아이디 */
  username: string;
  /** 비밀번호 */
  password: string;
};

/** @category useCheckPw */
export type TypeCheckPwResponse = {
  /** 응답 메시지 */
  message: string;
  data: {
    passToken: string;
  };
};

/**
 * @description 정보 보호를 위해 비밀번호 확인 api 요청에 사용되는 커스텀 훅
 */
export const useCheckPw = () => {
  const { mutateAsync } = useMutation({
    mutationFn: (params: TypeCheckPwParams) => {
      const endpoint = '/labor-accounts/check-password';
      return axiosInstance.post(endpoint, params);
    },
    gcTime: 0,
  });

  const requestCheckPw = async ({
    params,
    onSuccess,
    onError,
  }: {
    params: TypeCheckPwParams;
    onSuccess?: (res: TypeCheckPwResponse) => void;
    onError?: (err: TypeErrorFormat) => void;
  }) => {
    return requestHelper(() => mutateAsync(params), onSuccess, onError);
  };

  return requestCheckPw;
};
